exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 768px) {\n  .dyna-travel-settings .locale .desc {\n    display: none;\n  }\n}\n", ""]);

// exports
